import type { ProductNodeBuilderProps } from '../../ProductNodeBuilder.model';
import { BatchLockablePercentField } from '../BatchLockablePercentField';

export function MultipleApplyLockablePercentField(props: ProductNodeBuilderProps) {
  return <BatchLockablePercentField {...props} isMultipleApply={true} />;
}
